module.exports = __webpack_public_path__ + "static/media/project-flowlin.fbc1777d.jpg";